import { render, staticRenderFns } from "./repairdispatch.vue?vue&type=template&id=8727d74a&scoped=true"
import script from "./repairdispatch.vue?vue&type=script&lang=js"
export * from "./repairdispatch.vue?vue&type=script&lang=js"
import style0 from "./repairdispatch.vue?vue&type=style&index=0&id=8727d74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8727d74a",
  null
  
)

export default component.exports